import { createRoot } from 'react-dom/client'
import { PricingPage } from './pages/PricingPage'
import { StatusPage } from './pages/StatusPage'
import { WaitlistPage } from './pages/WaitlistPage'
import './styles.css'

function App() {
  const { pathname } = window.location
  if (pathname === '/status') return <StatusPage />
  if (pathname === '/pricing') return <PricingPage />
  return <WaitlistPage />
}

const rootElement = document.getElementById('root')

if (!rootElement) throw new Error('Unable to find the root element.')

createRoot(rootElement).render(<App />)
